import React, { createContext, useState } from "react";

const ClassificacaoServicoContext = createContext();

const ClassificacaoServicoProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [classId, setClassId] = useState(null);

  /**
   * Principal
   */
  const [active, setActive] = useState(true);
  const [description, setDescription] = useState("");
  const [value, setValue] = useState("0,00");
  const [serviceType, setServiceType] = useState({
    label: "Avulso",
    value: "A",
  });

  const [companies, setCompanies] = useState([]);
  const [costCenters, setCostCenters] = useState([]);
  const [selectedCostCenter, setSelectedCostCenter] = useState(null);
  const [tableSetCostCenters, setTableSetCostCenters] = useState([]);
  const [percentage, setPercentage] = useState("100,00");
  const [activeStep, setActiveStep] = useState(0);

  const [listServiceType] = useState([
    { label: "Avulso", value: "A" },
    { label: "Recorrente", value: "R" },
  ]);

  const [ratioLimitPercentage, setRatioLimitPercentage] = useState("100,00");

  const [servicos, setServicos] = useState(null);
  const [nbs, setNbs] = useState(null);
  const [indicadorOperacao, setIndicadorOperacao] = useState(null);
  const [classificacaoTributaria, setClassificacaoTributaria] = useState(null);
  const [codigoTributacao, setCodigoTributacao] = useState(null);
  const [perfilTributario, setPerfilTributario] = useState(null);

  const [classificacaoOptions, setClassificacaoOptions] = useState([]);
  const [perfilTributarioOptions, setPerfilTributarioOptions] = useState([]);
  const [indicadorOptions, setIndicadorOptions] = useState([]);
  const [codTributacaoOptions, setCodTributacaoOptions] = useState([]);
  const [nbsOptions, setNbsOptions] = useState([]);
  const [servicosOptions, setServicosOptions] = useState([]);

  return (
    <ClassificacaoServicoContext.Provider
      value={{
        loading,
        setLoading,
        active,
        setActive,
        description,
        setDescription,
        value,
        setValue,
        listServiceType,
        serviceType,
        setServiceType,
        companies,
        setCompanies,
        costCenters,
        setCostCenters,
        tableSetCostCenters,
        setTableSetCostCenters,
        errors,
        setErrors,
        percentage,
        setPercentage,
        activeStep,
        setActiveStep,
        selectedCostCenter,
        setSelectedCostCenter,
        classId,
        setClassId,

        ratioLimitPercentage,
        setRatioLimitPercentage,
        servicos,
        setServicos,
        nbs,
        setNbs,
        indicadorOperacao,
        setIndicadorOperacao,
        classificacaoTributaria,
        setClassificacaoTributaria,
        codigoTributacao,
        setCodigoTributacao,
        perfilTributario,
        setPerfilTributario,
        classificacaoOptions,
        setClassificacaoOptions,
        indicadorOptions,
        setIndicadorOptions,
        codTributacaoOptions,
        setCodTributacaoOptions,
        nbsOptions,
        setNbsOptions,
        servicosOptions,
        setServicosOptions,
        perfilTributarioOptions,
        setPerfilTributarioOptions,
      }}
    >
      {children}
    </ClassificacaoServicoContext.Provider>
  );
};

export { ClassificacaoServicoProvider, ClassificacaoServicoContext };
